import { render, staticRenderFns } from "./CusCenter.vue?vue&type=template&id=2ebdef6d&scoped=true"
import script from "./CusCenter.vue?vue&type=script&lang=js"
export * from "./CusCenter.vue?vue&type=script&lang=js"
import style0 from "./CusCenter.vue?vue&type=style&index=0&id=2ebdef6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdef6d",
  null
  
)

export default component.exports